import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import GoogleCloudSignUpModal from '../../components/ui/modals/GoogleCloudSignUpModal';
import { getPopupOptions } from '../../utils/getPopupConfiguration';

const GoogleCloudSignUp = () => {
  const { isLoading, loginWithPopup, error, isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userEmail = searchParams.get('email');

  useEffect(() => {
    if (error || isAuthenticated) navigate('/dashboard');
  }, [error, navigate, isAuthenticated]);

  const formatEmail = (email) => {
    if (email.includes(' ')) {
      return email.replace(' ', '+');
    }
    return email;
  };

  return isLoading ? null : (
    <GoogleCloudSignUpModal
      openModal={async () => {
        const popup = getPopupOptions();
        const formattedEmail = formatEmail(userEmail);
        await loginWithPopup(
          {
            login_hint: formattedEmail || '',
            screen_hint: 'signup',
          },
          { popup, timeoutInSeconds: 1000 }
        );
      }}
    />
  );
};

export default GoogleCloudSignUp;
